import CompanyInformation from './CompanyInformation';
export { CompanyInformation };
export default CompanyInformation;
